import { css } from 'styled-components';

export const Accessibility = css`
  @media (prefers-reduced-motion) {
    // https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
    * {
      transition: none !important;
    }
  }

  :focus {
    outline: none;
  }

  :focus-visible {
    outline: 3px solid var(--focus-color, currentColor);
    outline-offset: var(--focus-offset, 0.3ch);
    outline-style: solid;
  }

  .screenreader-only {
    position: absolute;
    display: inline-block;
    width: 1px;
    height: 1px;
    overflow: hidden;
    color: transparent;
    opacity: 0;
  }

  .screenreader-only-table-header {
    font-size: 1px;
    color: transparent;
    opacity: 0;
  }
`;
